import { Thing, WithContext } from 'schema-dts';
import { JSX } from 'react';

export const JsonLdUtil = {
  withContext: <T extends Thing>(input: T): WithContext<T> => {
    return Object.assign(
      {
        '@context': 'https://schema.org',
      },
      input,
    ) as WithContext<T>;
  },
  buildScriptTag: <T extends Thing>(input: T): JSX.Element => {
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(JsonLdUtil.withContext(input)),
        }}
      />
    );
  },
};
